// frontend/src/utils/auth.js
// ✅ دوال مساعدة للمصادقة - موحدة مع tokenManager

import tokenManager from './tokenManager';
import { SecureStorage } from './secureStorage';

/**
 * ✅ مسح جميع بيانات المصادقة
 */
export const clearAuth = (userRole = null) => {
  if (!userRole) {
    userRole = localStorage.getItem('userRole') || 'client';
  }
  
  tokenManager.clearAllData(userRole);
  SecureStorage.clearAll();
  
  console.log(`✅ Authentication cleared for ${userRole}`);
};

/**
 * ✅ تعيين التوكن
 */
export const setAuthToken = (token, userRole) => {
  if (!token || !userRole) {
    console.error('❌ Cannot set token: missing token or userRole');
    return;
  }
  
  tokenManager.saveToken(token, userRole);
  tokenManager.scheduleTokenRefresh(token, userRole);
  
  console.log(`✅ Auth token set for ${userRole}`);
};

/**
 * ✅ الحصول على التوكن المخزن
 */
export const getStoredToken = (userRole = null) => {
  if (!userRole) {
    userRole = localStorage.getItem('userRole');
  }
  
  return tokenManager.getStoredToken(userRole);
};

/**
 * ✅ تسجيل الخروج
 */
export const logout = async (redirectTo = null) => {
  const userRole = localStorage.getItem('userRole') || 'client';
  
  // إذا لم يُحدد مسار إعادة التوجيه، استخدم المسار الافتراضي
  if (!redirectTo) {
    redirectTo = userRole === 'agent' 
      ? '/agent/login'
      : userRole === 'admin'
      ? '/admin/login'
      : '/login';
  }
  
  await tokenManager.logout(userRole);
};

/**
 * ✅ التحقق من أن المستخدم مسجل دخوله
 */
export const isAuthenticated = (userRole = null) => {
  if (!userRole) {
    userRole = localStorage.getItem('userRole');
  }
  
  if (!userRole) return false;
  
  const token = tokenManager.getStoredToken(userRole);
  return token && tokenManager.isTokenValid(token);
};

/**
 * ✅ الحصول على معلومات المستخدم الحالي
 */
export const getCurrentUser = (userRole = null) => {
  if (!userRole) {
    userRole = localStorage.getItem('userRole');
  }
  
  const token = tokenManager.getStoredToken(userRole);
  
  if (!token) return null;
  
  return tokenManager.getTokenInfo(token);
};

/**
 * ✅ التحقق من الصلاحيات (للأدمن والوكلاء فقط)
 */
export const hasPermission = (permission) => {
  const userRole = localStorage.getItem('userRole');
  
  if (userRole === 'client') return false;
  
  try {
    const permissionsKey = userRole === 'agent' ? 'agentPermissions' : 'adminPermissions';
    const permissions = JSON.parse(localStorage.getItem(permissionsKey) || '[]');
    return permissions.includes(permission);
  } catch (error) {
    console.error('❌ Failed to check permission:', error);
    return false;
  }
};

/**
 * ✅ تهيئة المصادقة عند بدء التطبيق
 */
export const initializeAuth = () => {
  tokenManager.initialize();
};

// ✅ تصدير tokenManager للوصول المباشر
export { tokenManager };